'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUBJECT = exports.SUBJECT = ['subject'];
var TO = exports.TO = ['to'];
var CC = exports.CC = ['cc'];
var BCC = exports.BCC = ['bcc'];
var FROM = exports.FROM = ['from'];
var FROM_EMAIL = exports.FROM_EMAIL = ['from', 'email'];
var FROM_NAME = exports.FROM_NAME = ['from', 'name'];
var CONNECTED_ACCOUNT_ADDRESS = exports.CONNECTED_ACCOUNT_ADDRESS = ['connectedAccountAddress'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/emailMetadataKeypaths.js
// module id = 699
// module chunks = 2 3